var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ viewBox: "0 0 14 14", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M12.333 7a5.334 5.334 0 1 1-3.866-5.127L9.513.827A6.667 6.667 0 1 0 13.666 7h-1.333zm-8.06-1.28l-.94.947 3 3L13 3l-.94-.947L6.333 7.78l-2.06-2.06z", fill: "#BABFBD" })
  );
});


// WEBPACK FOOTER //
// ./src/static/images/icons/checkbox-marked-circle-outline.svg